export const times = (obj, amount) => ([...new Array(amount)]).map((_v, i) => obj(i));
